import { IRoute } from 'interfaces/routesInt';
import protectedRoutes from './protected';
import publicRoutes from './public';

const routes: IRoute[] = [...publicRoutes, ...protectedRoutes];

export default routes;
